import React from 'react';

// three bars with a downward arrow: content pushing what sits below it.
// 2px strokes: between the 1.5px line icons and the solid ones around it.
function Stack({ size }) {
  return (
    <svg
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 6h9M4 12h9M4 18h9" />
      <path d="M18.5 5v14M15.5 16l3 3 3-3" />
    </svg>
  );
}

export default Stack;
